<template>
  <div class="container">
    <div class="top">
      <p class="name">
        <span>客户管理</span>
        <span>&nbsp;&nbsp;(共{{total?total:0}}人)</span>
      </p>
      <div class="search-wrap">
        <el-input
          class="search"
          placeholder="请输入姓名/手机号/客户标签"
          v-model="searchStr"
          @input ="inputChange(searchStr)"
          >
        <i slot="suffix"
          class="el-input__icon el-icon-search"
          @click="querySearch(searchStr)"
        ></i>
        </el-input>
        <el-button type="primary" @click="addCouster">添加客户</el-button>
      </div>
    </div>
    <div class="tipes" >说明：客户列表中的成员可免费在润泽食堂用餐。</div>
    <div>
      <el-table :data="mates"
                align='center'
                style="width: 100%">
        <el-table-column prop="name"
                        align='center'
                        label="姓名"
                        >
        </el-table-column>
        <el-table-column prop="phone"
                        align='center'
                        label="手机号码"
                        >
        </el-table-column>
        <el-table-column prop="tag"
                        align='center'
                        label="客户标签"
                        width="200"
                        >
        </el-table-column>
        <el-table-column prop="creteTime"
                        align='center'
                        label="加入时间"
                        >
        </el-table-column>
        <el-table-column
                        align='center'
                        label="操作"
                        >
          <template slot-scope="scope">
            <!-- 直接在click事件上把当前要操作的用户的信息赋值了，省去了在写一个方法，不过这种写法合适不合适需要讨论 -->
            <el-button @click.native.prevent="editClick(scope.row)"
                      type="text">
              修改信息
            </el-button>
            <el-button @click.native.prevent="delVisible = true;userId =  scope.row.userId;currentName =  scope.row.realname; account = scope.row.account"
                      type="text">
              删除客户
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :page-size="10"
        align='center'
        @current-change="pageChange"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      title="添加客户"
      :visible.sync="addVisible"
      align='center'
      width="30%">
      <el-input v-model="employeeName" :maxlength="10" placeholder="请输入客户姓名"></el-input>
      <el-input v-model="phone" style='margin: 20px 0px' :maxlength="11" placeholder="请输入客户手机号"></el-input>
      <el-select
        class="select"
        v-model="tagValue"
        size="small"
      >
        <li class="addTagText">
          <span class='name' @click='addTags'>+ 新增标签</span>
          <el-input
            v-model="addText"
            class="input"
            placeholder="请输入标签内容"
            v-show='addInput'
            :maxlength="10"
            @keyup.enter.native='addTagSure()'

          >
          <i slot="suffix"
            class="el-input__icon el-icon-check"
            @click="addTagSure()"
            ></i>
          </el-input>
        </li>
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.name"
          :value="item.name"
        >
          <span>{{item.name}}</span>
          <span  class="delIcon el-icon-close" @click.stop='deleteTag(item.id)'></span>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser">确 定 添 加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改客户信息"
      :visible.sync="editVisible"
      @close='closeDialog'
      align='center'
      width="30%">
      <el-input v-model="oldTagValue"   :maxlength="10" placeholder="请输入员工姓名" ></el-input>
      <el-input v-model="oldTagPhone"  :maxlength="11" style='margin: 20px 0px' placeholder="请输入员工手机号"></el-input>
      <el-select
        class="select"
        v-model="oldTagSelect"
        size="small"
      >
        <li class="addTagText">
          <span class='name' @click='addTags'>+ 新增标签</span>
          <el-input
            v-model="addText"
            class="input"
            placeholder="请输入标签内容"
            v-show='addInput'
            :maxlength="10"
            @keyup.enter.native='addTagSure()'
          >
          <i slot="suffix"
            class="el-input__icon el-icon-check"
            @click="addTagSure()"
            ></i></el-input>
        </li>
        <el-option
          v-for="(item,index) in options"
          :key="index"
          :label="item.name"
          :value="item.name"
        >
          <span>{{item.name}}</span>
          <span  class="delIcon el-icon-close" @click.stop='deleteTag(item.id)'></span>
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser">确 定 修 改</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="'确定删除该客户'"
      :visible.sync="delVisible"
      align='center'
      width="30%">
      <div class="box">
        <span class="font">删除后，该客户将无法继续在【润泽食堂】免费用餐</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delVisible = false">取 消</el-button>
        <el-button type="primary" @click="delMate">确 定 删 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script >
import { getCustomerData, addCustomer, editCustomer, delCustomer, serMatesByCustomer, getMateTag, addMateTag, deleteMateTag, getMateNameByPhone } from '@/api/customer'
import bus from '@/utils/bus'
import { validateTel } from '@/utils/validate'
export default {
  data () {
    return {
      tableData: [],
      addVisible: false,
      editVisible: false,
      delVisible: false,
      delVisibles: false,
      input: '',
      radio: 1,
      mates: [],
      companyId: '',
      searchStr: '',
      currentId: '', // 当前要操作的用户
      employeeName: '',
      phone: '',
      showTip: 1, // 2的时候为第二种情况，提示有员工，可继续添加   3的时候为该手机号码已存在当前组织中，提示语为红色，添加按钮为灰色，不可添加
      tipMsg: '',
      userNumber: '',
      deductionInput: '',
      tipShow: false,
      succ: false,
      userId: '',
      isDisable: false,
      page: 1,
      pageSize: 10,
      options: [],
      tagValue: '',
      oldTagValue: '',
      oldTagPhone: '',
      oldTagSelect: '',
      addInput: false,
      addText: '',
      status: true,
      total: ''
    }
  },
  props: [],
  components: {
  },
  mounted () {
    this.companyId = localStorage.companyId
    this.getMates(1)
    // window.addEventListener('scroll', this.loadMore,true);
  },
  created () {
  },
  computed: {
    newSearchStr () {
      // this.querySearch(searchStr);
      this.searchStr + ''
      console.log(this.searchStr)
    }
  },
  watch: {
    phone (newValue, oldValue) {
      if (validateTel(newValue)) {
        getMateNameByPhone({ phone: newValue, companyId: localStorage.companyId }).then(res => {
          console.log(res)
          if (res.msg === 'success' && res.data) {
            this.showTip = 2
            this.tipMsg = `该用户注册名称：${res.data}`
          } else if (res.msg != 'success') {
            this.showTip = 3
            this.tipMsg = res.msg
          }
        })
      } else {
        this.showTip = 1
        this.tipMsg = ''
      }
    },
    options (val) {
      console.log(val)
      // if (val.length == 0 || val == undefined) {
      //   val.push({id: '0', name: '暂无数据'});
      // }
      // console.log(val);
    }
  },
  methods: {
    // 新增客户
    addCouster () {
      this.addVisible = true
      let data = { companyId: localStorage.companyId }
      getMateTag(data).then(res => {
        // console.log(res);
        if (res.length > 0) {
          this.options = res
        } else {
          this.options.push({ id: '0', name: '暂无数据' })
        }
      })
    },
    // 增加标签弹框显示
    addTags () {
      this.addInput = !this.addInput
    },
    // 确认增加标签
    addTagSure () {
      if (!this.addText) {
        this.$message('标签内容不能为空')
        return
      }
      let data = {
        companyId: localStorage.companyId,
        name: this.addText
      }
      addMateTag(data).then(res => {
        // console.log(res);
        this.addText = ''
        getMateTag(data).then(res => {
          // console.log(res);
          this.options = res
          if (this.options.length == 0) {
            this.options.push({ id: '0', name: '暂无数据' })
          }
        })
      })
      this.addInput = false
    },
    // 删除客户
    delMate () {
      let data = {
        companyId: localStorage.companyId,
        userId: this.userId
      }
      let _that = this
      delCustomer(data).then(res => {
        console.log(res)
        // if (res.msg === 'success') {
        _that.$message({
          type: 'success',
          message: '删除成功'
        })
        _that.delVisible = false
        _that.getMates(_that.page)
        // } else {
        //   _that.$message({
        //     type: 'warn',
        //     message: res.msg
        //   })
        // }
      }).catch(err => {
        console.log(err)
      })
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 获取客户列表
    getMates (pages) {
      let data = {
        companyId: this.companyId,
        page: pages,
        size: this.pageSize
      }
      getCustomerData(data).then(res => {
        this.mates = res.data.data
        this.total = res.data.count
      })
    },
    // 修改客户信息
    editClick (obj) {
      console.log(obj)
      this.currentId = obj.id
      this.oldTagValue = obj.name
      this.oldTagPhone = obj.phone
      this.oldTagSelect = obj.tag
      let data = { companyId: localStorage.companyId }
      getMateTag(data).then(res => {
        console.log(res)
        this.options = res
        if (this.options.length == 0) {
          this.options.push({ id: '0', name: '暂无数据' })
        }
      })
      this.editVisible = true
    },
    // 确认修改客户信息
    editUser () {
      if (!this.oldTagValue) {
        this.$message('请输入姓名')
        return
      }
      if (!validateTel(this.oldTagPhone)) {
        this.$message('请输入正确的手机号')
        return
      }
      let data = {
        id: this.currentId,
        name: this.oldTagValue,
        phone: this.oldTagPhone,
        tag: this.oldTagSelect
      }
      editCustomer(data).then(res => {
        console.log(res)
        // if (res.msg === 'success') {
        this.$message({
          type: 'success',
          message: '编辑成功'
        })
        this.editVisible = false
        this.getMates(this.page)
        // } else {
        //   this.$message({
        //     type: 'warn',
        //     message: res.msg
        //   })
        // }
      })
    },
    // 确认新增客户
    addUser () {
      if (!this.employeeName) {
        this.$message('请输入姓名')
        return
      }
      if (!validateTel(this.phone)) {
        this.$message('请输入正确的手机号')
        return
      }
      let data = {
        name: this.employeeName,
        phone: this.phone,
        companyId: localStorage.companyId,
        tag: this.tagValue
      }
      addCustomer(data).then(res => {
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addVisible = false
          this.employeeName = ''
          this.phone = ''
          this.tagValue = ''
          this.getMates(1)
        } else {
          this.$message({
            type: 'warn',
            message: res.msg
          })
        }
      })
    },
    timeFomatter (row, col) {
      return new Date(row[col.property]).toLocaleString()
    },
    moenyFomat (row, col) {
      return parseFloat(row[col.property]).toFixed(2)
    },
    statusFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 0:
          str = '未激活'
          break
        case 1:
          str = '正常'
          break
      }
      return str
    },
    idFormatter (row, col) {
      let str = row[col.property]
      switch (str) {
        case 1:
          str = '福利制表人/福利审核人'
          break
        case 2:
          str = '福利审核人'
          break
        case 3:
          str = '福利制表人'
          break
        case 4:
          str = '普通员工'
          break
      }
      return str
    },
    // 搜索客户
    querySearch (queryString) {
      console.log(queryString)
      if (queryString.length > 0) {
        let data = {
          companyId: localStorage.companyId,
          page: this.page,
          size: 10,
          keyword: queryString
        }
        serMatesByCustomer(data).then(res => {
          this.mates = res.data.data
          this.total = res.data.count
        })
      } else {
        this.getMates(this.page)
      }
    },
    inputChange (val) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (val) {
        this.timer = setTimeout(() => {
          this.querySearch(val)
        }, 500)
      } else {
        this.querySearch(val)
      }
    },
    // 切换弹窗
    deductionBox () {
      this.delVisible = false
      setTimeout(() => {
        this.delVisibles = true
      }, 500)
    },
    // 关闭弹窗
    handleDialogClose () {
      this.delVisibles = false
      this.succ = false
      setTimeout(() => {
        this.deductionInput = ''
      }, 500)
    },
    // 删除标签
    deleteTag (id) {
      deleteMateTag(id).then(res => {
        this.oldTagSelect = ''
        this.tagValue = ''
        let data = { companyId: localStorage.companyId }
        getMateTag(data).then(res => {
          this.options = res.data
        })
      })
    },
    pageChange (val) {
      console.log(val)
      this.page = val
      this.querySearch(this.searchStr)
    }
  }
}
</script>

<style scoped lang="scss">
%row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.container{
  .top{
    @extend %row;
    justify-content: space-between;
    // margin-bottom: 20px;
    .name{
      flex-basis: 68%;
    }
    .search-wrap{
      flex:1;
    }
    .search{
      width: 60%;
      margin-right:8%;
    }
  }
  .tipes{
    font-size: 14px;
    color:#AAAAAA;
    margin-bottom: 10px;
  }
}
.tip{
  color:#409EFF;
  cursor:pointer;
}
.error{
  color: lightcoral;
}
.box{
  display: flex;
  justify-content: space-between;
  .font{
    font-size: 14px;
    line-height: 20px;
  }
}
.dialog-footer{
  display: flex;
  justify-content: space-around;
  .el-button--primary{
    background:#2ecc74;
    border:1px solid #2ecc74;
  }
}
.confirm{
  text-align: center;
  .box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .font{
      flex-basis:20%;
      font-size: 14px;
      line-height: 20px;
      text-align: left;
    }
    .input{
      flex-basis:65%;
      flex: 1;
    }
    .unit{
      flex-basis:5%;
      text-align: right;
    }
  }
  .prompt{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:20px;
    .text{
      font-size: 14px;
      line-height: 20px;
    }
    .assignment{
      cursor:pointer;
    }
  }
  .tips{
    font-size: 12px;
    line-height: 18px;
    color:#FF5000;
    text-align: left;
    margin-top: 11px;
  }
  .remark{
    font-size: 12px;
    line-height: 18px;
    color:#999999;
    text-align: left;
    margin-top: 20px;
  }
  .hidden{
    display: none;
  }
}
.succ{
  .boxs{
    display: flex;
    justify-content: flex-start;
    .font{
      .color{
        color:#409EFF;
      }
    }
  }
}
::v-deep .el-select {
    display: block;
    position: relative;
}
.select{
  ::v-deep  .el-input--small .el-input__inner{
    width:100%;
    height: 40px;
    line-height: 40px;
  }
}
.addTagText{
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .name{
    display: block;
    font-size: 16px;
    line-height: 40px;
    color: #027DB4;
    cursor: pointer;
  }
  .input{
    height:40px;
    ::v-deep  .el-input__inner{
      height: 34px;
      line-height: 34px;
    }

  }
}
.delIcon{
  width:20px;
  height:20px;
  position: absolute;
  top:30%;
  right:2%;
  z-index: 10;
  display: none;
}
::v-deep  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover .delIcon{
  display: block;
}
</style>
